var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: " page-wrapper member-wrap"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('div', {}, [_c('div', {
    staticClass: "claim-wrap"
  }, [_c('div', {
    staticClass: "claim-contents"
  }, [_c('div', {
    staticClass: "claim-title"
  }, [_c('h1', [_vm._v("Invoice Data - " + _vm._s(_vm.invoiceList.member_info.cfname) + " " + _vm._s(_vm.invoiceList.member_info.clname))]), _c('button', {
    staticClass: "clear-search",
    on: {
      "click": _vm.clearData
    }
  }, [_vm._v(" Clear Search ")])]), _c('invoice-filter', {
    attrs: {
      "filters": _vm.filterQuery
    },
    on: {
      "onSearch": _vm.filterData
    }
  }), _c('div', {
    staticClass: "claim-btn-wrap"
  }), _c('div', {
    staticClass: "claim-list-tbl mt-3 table-responsive"
  }, [_c('div', {
    staticClass: "top-pagination"
  }, [_c('pagination', {
    attrs: {
      "rows": _vm.invoiceList,
      "filters": _vm.filterQuery
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.invoiceList = $event;
      }
    }
  })], 1), _c('invoice-table', {
    attrs: {
      "billingInvoice": _vm.invoiceList,
      "formatDate": _vm.formatDate,
      "statusClass": _vm.statusClass
    },
    on: {
      "refundHandler": _vm.onClickRefund
    }
  }), _c('pagination', {
    attrs: {
      "rows": _vm.invoiceList,
      "filters": _vm.filterQuery
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.invoiceList = $event;
      }
    }
  })], 1)], 1)])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }